module.exports = __webpack_public_path__ + "static/media/analytics_empty.385a52f4.png";